import { useState } from 'react';
import { TicketList } from './TicketList/TicketList';
import { ChatWindow } from './ChatWindow/ChatWindow';
import styles from './UserChat.module.scss';

export const UserChat = () => {
  const [selectedTicketId, setSelectedTicketId] = useState<number | null>(null);

  return (
    <div className={styles.container}>
      <TicketList
        selectedTicketId={selectedTicketId}
        onSelect={setSelectedTicketId}
      />
      <ChatWindow selectedTicketId={selectedTicketId} />
    </div>
  );
};
